/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LmsEventDetails } from '../../model/lms-event-details.model';
import { MenuItem } from '../../model/menu-item.model';
import { Tab } from '../../model/tab.model';
import { AppUtilityService } from '../../services/app-utility.service';
import { ConfigService } from '../../services/config.service';
import { LmsMenuService } from '../../services/lms-menu.service';
import { StaticDataStoreService } from '../../services/static-datastore.service';
import { environment } from './../../../../environments/environment';


/**
 * This menu item component created for left menu items
 * which present in side navigation.
 * @export
 * @class LmsMenuItemComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-menu-item',
  templateUrl: './lms-menu-item.component.html',
  styleUrls: ['./lms-menu-item.component.scss']
})

export class LmsMenuItemComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('subMenuItem') subMenuItemRef: any;

  @Input() menuItem: MenuItem;

  @Input() currentUrl: string;

  @Input() tabs: Tab[];

  @Input() tabsIndex: any;

  @Input() editMode: Boolean;
  @Output() lmsTabChange = new EventEmitter<LmsEventDetails>();

  searchText: string;

  selectedTab: Tab;

  selectedSubType: string;

  lastSelectTab: Tab;

  filteredTabs: Tab[];


  /**
   * Creates an instance of LmsMenuItemComponent.
   * @param {ConfigService} configService
   * @param {Router} router
   * @memberOf LmsMenuItemComponent
   */
  constructor(private configService: ConfigService, private appUtilService: AppUtilityService,
    private router: Router, private lmsMenuService: LmsMenuService, private staticDataStoreService: StaticDataStoreService) {
  }

  /**
   * This invoked when component is load.
   * @memberOf LmsMenuItemComponent
   */
  ngOnInit() {
    this.init();
  }

  /**
  * This method invoked when any change is done in tabs.
  * @param {SimpleChanges} changes
  * @memberOf LmsTabsComponent
  */
  ngOnChanges(changes: SimpleChanges) {
    const tabChanged: boolean = changes['tabs'] && (changes['tabs'].currentValue !== changes['tabs'].previousValue);
    if (tabChanged) {
      this.init();
    }
  }

  /**
   * This method initialize subtype, filter tabs (tabs according to selected menu type),
   * last selected tab
   * @private
   * @memberOf LmsMenuItemComponent
   */
  private init() {
    this.selectedSubType = this.menuItem && this.menuItem.defaultSubType;
    if (this.tabs && this.tabs.length > 0) {
      this.filteredTabs = this.tabs.filter((tab) => { return this.menuItem.type === tab.type; });
      this.selectedTab = this.tabs.find((data) => { return data.selected; });
      if (!this.lastSelectTab && this.filteredTabs && this.filteredTabs.length > 0) {
        this.lastSelectTab = this.filteredTabs[0];
      }
    }
  }

  /**
   * This method invoked when click is triggered on menu item from side navigation.
   * @param {any} $event
   * @memberOf LmsMenuItemComponent
   */
  click($event) {
    if (this.menuItem && this.menuItem.showOnly && this.menuItem.showOnly === this.currentUrl) {
      return;
    }
    const userProfile = this.staticDataStoreService.getValue('userProfile');
    const managerDesk = this.staticDataStoreService.getValue('commonopsPicklist');
    if (this.menuItem.tabSupported) {
      if (this.filteredTabs.length === 0) {
        if (this.menuItem.type === 'Outlying-Points') {
          let isDeskPresent = false;
          if (managerDesk && managerDesk.masterData) {
            for (let i = 0; i < managerDesk.masterData.zoneList.length; i++) {
              if (userProfile.alertDesk && (userProfile.alertDesk.trim().toLowerCase() === managerDesk.masterData.zoneList[i].zoneCode.trim().toLowerCase())) {
                isDeskPresent = true;
                break;
              }
            }
          }
          if (isDeskPresent) {
            this.router.navigateByUrl(
              `${this.menuItem.type.toLowerCase()}/${this.menuItem.defaultSubType.toLowerCase()}/${new Date().getTime()}?search=${userProfile.alertDesk}`,
              { skipLocationChange: environment.hideUrl });
          } else {
            this.router.navigateByUrl(
              `${this.menuItem.type.toLowerCase()}/${this.menuItem.defaultSubType.toLowerCase()}/${new Date().getTime()}`,
              { skipLocationChange: environment.hideUrl });
          }

        } else {
          this.router.navigateByUrl(
            `${this.menuItem.type.toLowerCase()}/${this.menuItem.defaultSubType.toLowerCase()}/${new Date().getTime()}`,
            { skipLocationChange: environment.hideUrl });
        }
      } else {
        this.router.
          navigateByUrl(`${this.lastSelectTab.type.toLowerCase()}/${this.lastSelectTab.subType.toLowerCase()}/${this.lastSelectTab.id}`,
          { skipLocationChange: environment.hideUrl });
      }
    } else {
      if (this.menuItem.defaultSubType) {
        if (this.filteredTabs.length === 0) {
          this.router.navigateByUrl(
            `${this.menuItem.url}/${this.menuItem.defaultSubType.toLowerCase()}/${new Date().getTime()}`,
            { skipLocationChange: environment.hideUrl });
        } else {
          this.router.
            navigateByUrl(`${this.lastSelectTab.type.toLowerCase()}/${this.lastSelectTab.subType.toLowerCase()}/${this.lastSelectTab.id}`,
            { skipLocationChange: environment.hideUrl });
        }
      } else {
        // if (this.menuItem.type === 'Help' && (this.selectedTab.type === 'Alerts' || this.lmsMenuService.getMenuItem(this.selectedTab.type).helpUrl)) {
        //   const url = this.appUtilService.getHelpUrl(this.selectedTab.type, this.selectedTab.subType);
        //   window.open(
        //     url,
        //     '_blank'
        //   );
        // } 
        if (this.menuItem.type === 'Help') {
          const url = this.menuItem.url;
          this.router.navigateByUrl(
            `${this.menuItem.url}`,
            { skipLocationChange: environment.hideUrl });
         
        } else if (this.menuItem.type === 'List Manager') {
          const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
          const url = commonopsPicklist.masterData.listManagerUrl;
          if (url) {
            window.open(
              url,
              '_blank'
            );
          }

        } else if (this.menuItem.type === 'Operations Phone Book') {
          const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
          const url = commonopsPicklist.masterData.phoneBookUrl;
          if (url) {
            window.open(
              url,
              '_blank'
            );
          }
        }else if (this.menuItem.type === 'Tonnage-Ratings') {
          console.log(this.menuItem)
         this.router.navigateByUrl(

            `${this.menuItem.url}/${this.menuItem.defaultSubType.toLowerCase()}/${new Date().getTime()}`,
            { skipLocationChange: environment.hideUrl });

        }
         else {
          this.router.navigateByUrl(
            `${this.menuItem.url}`,
            { skipLocationChange: environment.hideUrl });
        }
      }
    }
  }

  /**
   * This method invoked when click on sub menu items.
   * @param {LmsEventDetails} lmsEventDetails
   * @memberOf LmsMenuItemComponent
   */
  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    if (lmsEventDetails.type === 'lastSelectTabChange') {
      this.lastSelectTab = lmsEventDetails.data;
    } else {
      this.lmsTabChange.emit(lmsEventDetails);
    }
  }

  /**
   * Destroy the state of lifecycle hook.
   * @memberOf LmsMenuItemComponent
   */
  ngOnDestroy() { }
}
